<template>
  <div id="groupsDisplayTechinicalsSpecificationsAdmin">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">{{ admin }}</li>
      <li class="breadcrumb-item active">
        <router-link :to="url">{{ groupsDisplay }}</router-link>
      </li>
    </ol>
    <div class="container-fluid">
      <div class="card">
        <div class="tab-content noborder">
          <div
            class="tab-pane nopadding active"
            id="tabGroupsDisplayTechinicalsSpecificationsAdminTable"
            role="tabpanel"
          >
            <div class="card-body card-body-table">
              <div class="row">
                <div class="col-sm-8">
                  <ul class="nav nav-tabs" role="tablist">
                    <li class="nav-item">
                      <button
                        id="tabGroup"
                        class="nav-link active"
                        type="button"
                        data-toggle="tab"
                        href="#tabGroupDisplayBody"
                        role="tab"
                        aria-controls="tabGroupDisplayBody"
                        v-on:click="onGroupDisplayTab"
                      >
                        <i class="fa fa-window-restore"></i>
                        <span>{{ groupsDisplay }}</span>
                      </button>
                    </li>
                    <li class="nav-item">
                      <button
                        id="tabTechnicalSpecification"
                        type="button"
                        class="nav-link"
                        data-toggle="tab"
                        href="#tabTechnicalSpecificationBody"
                        role="tab"
                        aria-controls="tabTechnicalSpecificationBody"
                        :disabled="disableTab"
                        v-on:click="onTechnicalSpecificationTab"
                      >
                        <i class="fa fa-bars"></i>
                        <span>{{ technicalSpecification }}</span>
                      </button>
                    </li>
                  </ul>
                </div>
                <div class="col-sm-4 text-right">
                  <span v-if="spanRowSelected != ''"
                    >{{ groupDisplay }}: <b>{{ spanRowSelected }}</b></span
                  >
                </div>
              </div>
              <div class="tab-content">
                <div
                  class="tab-pane active"
                  id="tabGroupDisplayBody"
                  role="tabpanel"
                >
                  <div class="row">
                    <div class="col-lg-6">
                      <button
                        id="btnAdd"
                        type="button"
                        class="btn btn-sm btn-primary"
                        @click="addGroupDisplayTechinicalsSpecifications"
                      >
                        <i class="fa fa-plus"></i>
                        <span>{{ add }}</span>
                      </button>
                      <button
                        id="btnSave"
                        type="button"
                        class="btn btn-sm btn-success"
                        @click="
                          confirmSaveGroupDisplayTechinicalsSpecifications
                        "
                        :disabled="disableButton"
                      >
                        <i class="fa fa-floppy-o"></i>
                        <span>{{ save }}</span>
                      </button>
                      <button
                        id="btnDelete"
                        type="button"
                        class="btn btn-sm btn-danger"
                        @click="
                          confirmDeleteGroupDisplayTechinicalsSpecifications
                        "
                        :disabled="disableButton"
                      >
                        <i class="fa fa-trash"></i>
                        <span>{{ del }}</span>
                      </button>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12">
                      <bootstrapTable
                        :configurations="tableConfigurations"
                        :datas="tableData"
                        id="tableGroupsDisplayTechinicalsSpecificationsAdmin"
                        :onCheck="onTableCheck"
                        :onCheckAll="onTableCheck"
                        :onUncheck="onTableCheck"
                        :onUncheckAll="onTableCheck"
                        ref="tableGroupsDisplayTechinicalsSpecificationsAdmin"
                        :results="tableResult"
                      ></bootstrapTable>
                    </div>
                  </div>
                </div>
                <div
                  class="tab-pane"
                  id="tabTechnicalSpecificationBody"
                  role="tabpanel"
                >
                  <div class="row">
                    <div class="col-sm-5">
                      <button
                        id="btnSaveOrderTechnicalSpecification"
                        type="button"
                        class="btn btn-sm btn-success"
                        @click="confirmSaveOrderTechinicalsSpecifications"
                        :disabled="disableOrderTechnicalSpecificationButton"
                      >
                        <i class="fa fa-floppy-o"></i>
                        <span>{{ save }}</span>
                      </button>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-5">
                      <bootstrapTable
                        :configurations="
                          tableTechnicalSpecificationIncludedConfiguration
                        "
                        :datas="tableTechnicalSpecificationIncludedData"
                        id="tableTechnicalsSpecificationsIncluded"
                        :onCheck="onTableIncludedCheck"
                        :onCheckAll="onTableIncludedCheck"
                        :onUncheck="onTableIncludedCheck"
                        :onUncheckAll="onTableIncludedCheck"
                        ref="tableTechnicalsSpecificationsIncluded"
                        :results="tableTechnicalSpecificationIncludedResult"
                      ></bootstrapTable>
                    </div>
                    <div class="col-sm-2 vertical-center">
                      <div class="container-fluid">
                        <div class="row">
                          <button
                            type="button"
                            class="btn btn-block btn-primary"
                            @click="addTechnicalSpecification"
                            :disabled="disableAddTechnicalSpecificationButton"
                          >
                            <i class="fa fa-arrow-left"></i>
                            <span>{{ add }}</span>
                          </button>
                        </div>
                        <div class="row">&nbsp;</div>
                        <div class="row">
                          <button
                            type="button"
                            class="btn btn-block btn-secondary"
                            @click="removeTechnicalSpecification"
                            :disabled="
                              disableRemoveTechnicalSpecificationButton
                            "
                          >
                            <i class="fa fa-arrow-right"></i>
                            <span>{{ remove }}</span>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-5">
                      <bootstrapTable
                        addInput="false"
                        :configurations="
                          tableTechnicalSpecificationExcludedConfiguration
                        "
                        :datas="tableTechnicalSpecificationExcludedData"
                        id="tableTechnicalsSpecificationsExcluded"
                        :onCheck="onTableExcludedCheck"
                        :onCheckAll="onTableExcludedCheck"
                        :onUncheck="onTableExcludedCheck"
                        :onUncheckAll="onTableExcludedCheck"
                        ref="tableTechnicalsSpecificationsExcluded"
                        :results="tableTechnicalSpecificationExcludedResult"
                      ></bootstrapTable>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="tab-pane nopadding"
            id="tabGroupsDisplayTechinicalsSpecificationsAdminDetail"
            role="tabpanel"
          >
            <div class="card-header">
              <div class="row">
                <div class="col-sm-12">
                  <strong>{{ newGroupDisplayTechnicalSpecification }}</strong>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
               <div v-if="rowIdSelected > 0">
                      <h1 style="margin-top: 10px; font-size: 30px;font-weight: lighter;color: #303C54;">Modifica</h1>
                      </div>
                      <div v-else>
                      <h1 style="margin-top: 10px; font-size: 30px;font-weight: lighter;color: #303C54;">Aggiungi</h1>
                      </div>
                <pageDetail
                  functions="groupsDisplayTechinicalsSpecificationsAdmin"
                  :configurations="detailConfigurations"
                  :jsonValue="detailValues"
                ></pageDetail>
              </div>
              <div class="row">
                <div class="col-lg-12 text-right">
                  <button
                    id="btnCancelNew"
                    type="button"
                    class="btn btn-danger"
                    @click="cancelNewGroupDisplayTechinicalsSpecifications"
                  >
                    <i class="fa fa-times"></i>
                    <span>{{ cancel }}</span>
                  </button>
                  <button
                    id="btnAddNew"
                    type="button"
                    class="btn btn-success"
                    @click="saveNewGroupDisplayTechinicalsSpecifications"
                  >
                    <i class="fa fa-floppy-o"></i>
                    <span>{{ save }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BootstrapTable from "@/components/BootstrapTable.vue";
import PageDetail from "@/components/PageDetail.vue";

export default {
  name: "groupsDisplayTechinicalsSpecificationsAdmin",
  components: {
    BootstrapTable,
    PageDetail
  },
  data() {
    return {
      add: dictionaryHelpers.getDictionary("Add"),
      admin: dictionaryHelpers.getDictionary("Admin"),
      cancel: dictionaryHelpers.getDictionary("Cancel"),
      confirmDeleteRowSelected: dictionaryHelpers.getDictionary("ConfirmDeleteRowSelected"),
      confirmSaveRowSelected: dictionaryHelpers.getDictionary("ConfirmSaveRowSelected"),
      configurations: [],
      del: dictionaryHelpers.getDictionary("Delete"),
      deleteCompleted: dictionaryHelpers.getDictionary("DeleteCompleted"),
      detailConfigurations: [],
      detailValues: {},
      disableAddTechnicalSpecificationButton: true,
      disableButton: true,
      disableOrderTechnicalSpecificationButton: true,
      disableRemoveTechnicalSpecificationButton: true,
      disableTab: true,
      excluded: dictionaryHelpers.getDictionary("Excluded"),
      frmGroupsDisplayTechinicalsSpecificationsAdmin: 'frmgroupsDisplayTechinicalsSpecificationsAdmin',
      groupDisplay: dictionaryHelpers.getDictionary("GroupDisplay"),
      groupsDisplay: dictionaryHelpers.getDictionary("GroupsDisplay"),
      included: dictionaryHelpers.getDictionary("Included"),
      insertCompleted: dictionaryHelpers.getDictionary("InsertCompleted"),
      idTabDetail: 'tabGroupsDisplayTechinicalsSpecificationsAdminDetail',
      idTabTable: 'tabGroupsDisplayTechinicalsSpecificationsAdminTable',
      moreRowSelected: dictionaryHelpers.getDictionary('MoreRowSelected'),
      newGroupDisplayTechnicalSpecification: dictionaryHelpers.getDictionary("NewGroupDisplayTechnicalSpecification"),
      noRowSelected: dictionaryHelpers.getDictionary('NoRowSelected'),
      save: dictionaryHelpers.getDictionary("Save"),
      sorting: dictionaryHelpers.getDictionary('Sorting'),
      spanRowSelected: '',
      tabGroup: '#tabGroup',
      tableConfigurations: [],
      tableData: [],
      tableTechnicalSpecificationIncludedConfiguration: [],
      tableTechnicalSpecificationIncludedData: [],
      tableTechnicalSpecificationIncludedResult: [],
      tableTechnicalSpecificationExcludedConfiguration: [],
      tableTechnicalSpecificationExcludedData: [],
      tableTechnicalSpecificationExcludedResult: [],
      tableResult: [],
      technicalSpecification: dictionaryHelpers.getDictionary("TechnicalSpecification"),
      groupDisplayTechnicalSpecification: dictionaryHelpers.getDictionary("GroupDisplayTechnicalSpecification"),
      groupDisplayTechnicalSpecificationAlreadyExists: dictionaryHelpers.getDictionary("GroupDisplayTechnicalSpecificationAlreadyExists"),
      remove: dictionaryHelpers.getDictionary("Remove"),
      rowsSelected: 0,
      updateCompleted: dictionaryHelpers.getDictionary("UpdateCompleted"),
      url: window.location.pathname
    };
  },
  computed: {

  },
  mounted() {
    var groupsDisplayTechinicalsSpecificationsAdmin = this;

    languageServices.getConfiguration(function (result) {
      groupsDisplayTechinicalsSpecificationsAdmin.configurations = result.data;

      var tablesConfigurations = groupsDisplayTechinicalsSpecificationsAdmin.configurations.tablesConfigurations;
      tablesConfigurations.push({
        'field': 'order',
        'inputType': 'Numeric',
        'visibleOnTable': true,
        'filterType': 'Numeric',
        'placeholder': groupsDisplayTechinicalsSpecificationsAdmin.sorting + '...',
        'required': true,
        'title': groupsDisplayTechinicalsSpecificationsAdmin.sorting
      });

      var detailConfigurations = groupsDisplayTechinicalsSpecificationsAdmin.configurations.tabsConfigurations[0].pageConfigurations;
      var posY = 1;
      $.each(detailConfigurations,function (i,configuration) {
        posY = configuration.posY + 1;
      });

      detailConfigurations.push({
        'colspan': 4,
        'field': 'order',
        'inputType': 'Numeric',
        'label': groupsDisplayTechinicalsSpecificationsAdmin.sorting,
        'posX': 1,
        'posY': posY,
        'required': true
      });


      groupsDisplayTechinicalsSpecificationsAdmin.tableConfigurations = tablesConfigurations;
      groupsDisplayTechinicalsSpecificationsAdmin.detailConfigurations = detailConfigurations;
      groupsDisplayTechinicalsSpecificationsAdmin.loadTableData();
    });

    groupsDisplayTechinicalsSpecificationsAdmin.tableTechnicalSpecificationIncludedConfiguration = [{
      'inputType': 'TableCheckbox',
      'visibleOnTable': true
    },
    {
      'field': 'description',
      'visibleOnTable': true,
      'filterType': 'Input',
      'title': groupsDisplayTechinicalsSpecificationsAdmin.included
    },
    {
      'field': 'order',
      'inputType': 'Numeric',
      'visibleOnTable': true,
      'filterType': 'Numeric',
      'title': groupsDisplayTechinicalsSpecificationsAdmin.sorting
    }];

    groupsDisplayTechinicalsSpecificationsAdmin.tableTechnicalSpecificationExcludedConfiguration = [{
      'inputType': 'TableCheckbox',
      'visibleOnTable': true
    },
    {
      'field': 'description',
      'visibleOnTable': true,
      'filterType': 'Input',
      'title': groupsDisplayTechinicalsSpecificationsAdmin.excluded
    }];
  },
  methods: {
    loadTableData() {
      var groupsDisplayTechinicalsSpecificationsAdmin = this;
      groupDisplayTechnicalSpecificationServices.getDtoTable(function (result) {
        groupsDisplayTechinicalsSpecificationsAdmin.tableData = result.data;
      });
      groupsDisplayTechinicalsSpecificationsAdmin.disableButton = true;
      groupsDisplayTechinicalsSpecificationsAdmin.disableTab = true;
      groupsDisplayTechinicalsSpecificationsAdmin.spanRowSelected = '';
      spinnerHelpers.hide();
    },
    addGroupDisplayTechinicalsSpecifications() {
      spinnerHelpers.show();
      var groupsDisplayTechinicalsSpecificationsAdmin = this;
      groupsDisplayTechinicalsSpecificationsAdmin.detailValues = {};
      $('#' + groupsDisplayTechinicalsSpecificationsAdmin.idTabTable).removeClass('active');
      $('#' + groupsDisplayTechinicalsSpecificationsAdmin.idTabDetail).addClass('active');
      spinnerHelpers.hide();
    },
    confirmSaveGroupDisplayTechinicalsSpecifications() {
      var groupsDisplayTechinicalsSpecificationsAdmin = this;
      if (groupsDisplayTechinicalsSpecificationsAdmin.$refs.tableGroupsDisplayTechinicalsSpecificationsAdmin.haveRowSelected(true)) {
        if (confirm(groupsDisplayTechinicalsSpecificationsAdmin.confirmSaveRowSelected)) {
          spinnerHelpers.show();
          groupsDisplayTechinicalsSpecificationsAdmin.saveGroupDisplayTechinicalsSpecifications();
        }
      }
    },
    saveGroupDisplayTechinicalsSpecifications() {
      var groupsDisplayTechinicalsSpecificationsAdmin = this;
      groupsDisplayTechinicalsSpecificationsAdmin.tableResult = [];

      $.each(groupsDisplayTechinicalsSpecificationsAdmin.$refs.tableGroupsDisplayTechinicalsSpecificationsAdmin.getRowSelected(),function (i,row) {
        var rowToSave = {};
        rowToSave.idFunctionality = menuHelpers.getIdFunctionByAdminUrl();
        rowToSave.groupDisplayTechnicalSpecificationLanguage = [];

        $.each(row,function (field,value) {
          switch (field) {
            case 'id':
              rowToSave.id = value;
              break;
            case 'order':
              rowToSave.order = value;
              break;
            case '0':
              break;
            default:
              var groupDisplayTechnicalSpecificationLanguage = {};
              groupDisplayTechnicalSpecificationLanguage.idLanguage = field;
              groupDisplayTechnicalSpecificationLanguage.description = value;
              rowToSave.groupDisplayTechnicalSpecificationLanguage.push(groupDisplayTechnicalSpecificationLanguage);
              break;
          }
        });

        groupsDisplayTechinicalsSpecificationsAdmin.rowsSelected = groupsDisplayTechinicalsSpecificationsAdmin.rowsSelected + 1;
        groupDisplayTechnicalSpecificationServices.update(rowToSave,
          function () {
            groupsDisplayTechinicalsSpecificationsAdmin.checkAllIsSaved();
            groupsDisplayTechinicalsSpecificationsAdmin.tableResult.push({ id: rowToSave.id,success: true });
            notificationHelpers.success(groupsDisplayTechinicalsSpecificationsAdmin.updateCompleted);
          },
          function (response) {
            groupsDisplayTechinicalsSpecificationsAdmin.checkAllIsSaved();
            groupsDisplayTechinicalsSpecificationsAdmin.tableResult.push({ id: rowToSave.id,success: false,message: response });
            notificationHelpers.error(response);
          });
      });
    },
    confirmDeleteGroupDisplayTechinicalsSpecifications() {
      var groupsDisplayTechinicalsSpecificationsAdmin = this;
      if (groupsDisplayTechinicalsSpecificationsAdmin.$refs.tableGroupsDisplayTechinicalsSpecificationsAdmin.haveRowSelected(true)) {
        if (confirm(groupsDisplayTechinicalsSpecificationsAdmin.confirmDeleteRowSelected)) {
          spinnerHelpers.show();
          groupsDisplayTechinicalsSpecificationsAdmin.deleteGroupDisplayTechinicalsSpecifications();
        }
      }
    },
    deleteGroupDisplayTechinicalsSpecifications() {
      var groupsDisplayTechinicalsSpecificationsAdmin = this;
      groupsDisplayTechinicalsSpecificationsAdmin.tableResult = [];

      $.each(groupsDisplayTechinicalsSpecificationsAdmin.$refs.tableGroupsDisplayTechinicalsSpecificationsAdmin.getRowSelected(),function (i,row) {
        groupsDisplayTechinicalsSpecificationsAdmin.rowsSelected = groupsDisplayTechinicalsSpecificationsAdmin.rowsSelected + 1;
        groupDisplayTechnicalSpecificationServices.del(row.id,
          function (id) {
            groupsDisplayTechinicalsSpecificationsAdmin.checkAllIsSaved();
            groupsDisplayTechinicalsSpecificationsAdmin.tableResult.push({ id: id,success: true });
            notificationHelpers.success(groupsDisplayTechinicalsSpecificationsAdmin.deleteCompleted);
          },
          function (response,id) {
            groupsDisplayTechinicalsSpecificationsAdmin.checkAllIsSaved();
            groupsDisplayTechinicalsSpecificationsAdmin.tableResult.push({ id: id,success: false,message: response });
            notificationHelpers.error(response);
          });
      });
    },
    checkAllIsSaved() {
      var groupsDisplayTechinicalsSpecificationsAdmin = this;
      groupsDisplayTechinicalsSpecificationsAdmin.rowsSelected = groupsDisplayTechinicalsSpecificationsAdmin.rowsSelected - 1;
      if (groupsDisplayTechinicalsSpecificationsAdmin.rowsSelected == 0) {
        groupsDisplayTechinicalsSpecificationsAdmin.loadTableData();
      }
    },
    cancelNewGroupDisplayTechinicalsSpecifications() {
      var groupsDisplayTechinicalsSpecificationsAdmin = this;
      spinnerHelpers.show();
      $('#' + groupsDisplayTechinicalsSpecificationsAdmin.idTabTable).addClass('active');
      $('#' + groupsDisplayTechinicalsSpecificationsAdmin.idTabDetail).removeClass('active');
      spinnerHelpers.hide();
    },
    saveNewGroupDisplayTechinicalsSpecifications() {
      if ($('.error').length) {
        notificationHelpers.error(dictionaryHelpers.getDictionary('RequiredFieldsNotCompleted'));
        validationHelpers.moveToInvalid();
      }
      else {
        var groupsDisplayTechinicalsSpecificationsAdmin = this;
        if (validationHelpers.isValid('#' + groupsDisplayTechinicalsSpecificationsAdmin.frmGroupsDisplayTechinicalsSpecificationsAdmin)) {
          spinnerHelpers.show();
          groupsDisplayTechinicalsSpecificationsAdmin.tableResult = [];
          groupDisplayTechnicalSpecificationServices.insert(groupsDisplayTechinicalsSpecificationsAdmin.convertDetailDataToSave(),function (result) {
            groupsDisplayTechinicalsSpecificationsAdmin.loadTableData();
            $('#' + groupsDisplayTechinicalsSpecificationsAdmin.idTabTable).addClass('active');
            $('#' + groupsDisplayTechinicalsSpecificationsAdmin.idTabDetail).removeClass('active');
            groupsDisplayTechinicalsSpecificationsAdmin.tableResult.push({ id: result.data,success: true,message: groupsDisplayTechinicalsSpecificationsAdmin.insertCompleted });
            notificationHelpers.success(groupsDisplayTechinicalsSpecificationsAdmin.insertCompleted);
          });
        }
      }
    },
    convertDetailDataToSave() {
      var groupsDisplayTechinicalsSpecificationsAdmin = this;
      var dataToSave = {};

      dataToSave.idFunctionality = menuHelpers.getIdFunctionByAdminUrl();
      dataToSave.groupDisplayTechnicalSpecificationLanguage = [];

      $.each(groupsDisplayTechinicalsSpecificationsAdmin.detailValues,function (field,value) {
        if (field == 'order') {
          dataToSave.order = value;
        }
        else {
          var groupDisplayTechnicalSpecificationLanguage = {};
          groupDisplayTechnicalSpecificationLanguage.idLanguage = field;
          groupDisplayTechnicalSpecificationLanguage.description = value;
          dataToSave.groupDisplayTechnicalSpecificationLanguage.push(groupDisplayTechnicalSpecificationLanguage);
        }
      });

      return dataToSave;
    },
    onChangeDetail(field,value) {
      var groupsDisplayTechinicalsSpecificationsAdmin = this;
      var _field = dataHelpers.unbind(field);
      if (functionHelpers.isValued(value)) {
        groupDisplayTechnicalSpecificationServices.checkExists(value,field,null,function (result) {
          if (result.data) {
            if (!$('#' + field).hasClass('error')) {
              $('#' + field).addClass('error');
            }
            notificationHelpers.error(groupsDisplayTechinicalsSpecificationsAdmin.groupDisplayTechnicalSpecificationAlreadyExists);
          }
          else {
            if ($('#' + field).hasClass('error')) {
              $('#' + field).removeClass('error');
            }
          }
        });
      }
      else {
        if ($('#' + field).hasClass('error')) {
          $('#' + field).removeClass('error');
        }
      }
    },
    onTableCheck() {
      var groupsDisplayTechinicalsSpecificationsAdmin = this;
      var countRowSelected = groupsDisplayTechinicalsSpecificationsAdmin.$refs.tableGroupsDisplayTechinicalsSpecificationsAdmin.countRowSelected();
      if (countRowSelected == 0) {
        groupsDisplayTechinicalsSpecificationsAdmin.disableButton = true;
        groupsDisplayTechinicalsSpecificationsAdmin.disableTab = true;
      } else {
        if (countRowSelected == 1) {
          groupsDisplayTechinicalsSpecificationsAdmin.disableTab = false;
        }
        else {
          groupsDisplayTechinicalsSpecificationsAdmin.disableTab = true;
        }
        groupsDisplayTechinicalsSpecificationsAdmin.disableButton = false;
      }
    },
    onGroupDisplayTab() {
      this.spanRowSelected = '';
    },
    onTechnicalSpecificationTab() {
      var groupsDisplayTechinicalsSpecificationsAdmin = this;
      var countRowSelected = groupsDisplayTechinicalsSpecificationsAdmin.$refs.tableGroupsDisplayTechinicalsSpecificationsAdmin.countRowSelected();
      if (countRowSelected == 0) {
        notificationHelpers.error(groupsDisplayTechinicalsSpecificationsAdmin.noRowSelected);
      }
      else {
        if (countRowSelected != 1) {
          notificationHelpers.error(groupsDisplayTechinicalsSpecificationsAdmin.moreRowSelected);
        }
        else {
          spinnerHelpers.show();
          groupsDisplayTechinicalsSpecificationsAdmin.spanRowSelected = groupsDisplayTechinicalsSpecificationsAdmin.$refs.tableGroupsDisplayTechinicalsSpecificationsAdmin.getRowSelected()[0][storageData.sIdLanguage()];
          groupsDisplayTechinicalsSpecificationsAdmin.disableAddTechnicalSpecificationButton = true;
          groupsDisplayTechinicalsSpecificationsAdmin.disableRemoveTechnicalSpecificationButton = true;
          groupDisplayTechnicalSpecificationServices.getTechnicalSpecification(groupsDisplayTechinicalsSpecificationsAdmin.$refs.tableGroupsDisplayTechinicalsSpecificationsAdmin.getRowSelected()[0].id,
            function (result) {
              if (functionHelpers.isValued(result.data)) {
                groupsDisplayTechinicalsSpecificationsAdmin.tableTechnicalSpecificationIncludedData = result.data.included;
                groupsDisplayTechinicalsSpecificationsAdmin.tableTechnicalSpecificationExcludedData = result.data.excluded;
              }
              spinnerHelpers.hide();
            });
        }
      }
    },
    onTableIncludedCheck() {
      var groupsDisplayTechinicalsSpecificationsAdmin = this;
      if (groupsDisplayTechinicalsSpecificationsAdmin.$refs.tableTechnicalsSpecificationsIncluded.haveRowSelected()) {
        groupsDisplayTechinicalsSpecificationsAdmin.disableOrderTechnicalSpecificationButton = false;
        groupsDisplayTechinicalsSpecificationsAdmin.disableRemoveTechnicalSpecificationButton = false;
      } else {
        groupsDisplayTechinicalsSpecificationsAdmin.disableOrderTechnicalSpecificationButton = true;
        groupsDisplayTechinicalsSpecificationsAdmin.disableRemoveTechnicalSpecificationButton = true;
      }
    },
    onTableExcludedCheck() {
      var groupsDisplayTechinicalsSpecificationsAdmin = this;
      if (groupsDisplayTechinicalsSpecificationsAdmin.$refs.tableTechnicalsSpecificationsExcluded.haveRowSelected()) {
        groupsDisplayTechinicalsSpecificationsAdmin.disableAddTechnicalSpecificationButton = false;
      } else {
        groupsDisplayTechinicalsSpecificationsAdmin.disableAddTechnicalSpecificationButton = true;
      }
    },
    addTechnicalSpecification() {
      var groupsDisplayTechinicalsSpecificationsAdmin = this;
      groupsDisplayTechinicalsSpecificationsAdmin.rowsSelected = 0;
      if (groupsDisplayTechinicalsSpecificationsAdmin.$refs.tableTechnicalsSpecificationsExcluded.haveRowSelected(true)) {
        spinnerHelpers.show();
        $.each(groupsDisplayTechinicalsSpecificationsAdmin.$refs.tableTechnicalsSpecificationsExcluded.getRowSelected(),function (i,row) {
          groupsDisplayTechinicalsSpecificationsAdmin.rowsSelected = groupsDisplayTechinicalsSpecificationsAdmin.rowsSelected + 1;
          groupDisplayTechnicalSpecificationServices.addTechnicalSpecification(groupsDisplayTechinicalsSpecificationsAdmin.$refs.tableGroupsDisplayTechinicalsSpecificationsAdmin.getRowSelected()[0].id,
            row.id,function (result) {
              groupsDisplayTechinicalsSpecificationsAdmin.checkAllTechnicalSpecificationIsSaved();
              notificationHelpers.success(groupsDisplayTechinicalsSpecificationsAdmin.updateCompleted);
            });
        });
      }
    },
    removeTechnicalSpecification() {
      var groupsDisplayTechinicalsSpecificationsAdmin = this;
      groupsDisplayTechinicalsSpecificationsAdmin.rowsSelected = 0;
      if (groupsDisplayTechinicalsSpecificationsAdmin.$refs.tableTechnicalsSpecificationsIncluded.haveRowSelected(true)) {
        spinnerHelpers.show();
        $.each(groupsDisplayTechinicalsSpecificationsAdmin.$refs.tableTechnicalsSpecificationsIncluded.getRowSelected(),function (i,row) {
          groupsDisplayTechinicalsSpecificationsAdmin.rowsSelected = groupsDisplayTechinicalsSpecificationsAdmin.rowsSelected + 1;
          groupDisplayTechnicalSpecificationServices.deleteGroupDisplayTechnicalSpecificationTechnicalSpecification(row.id,function (result) {
            groupsDisplayTechinicalsSpecificationsAdmin.checkAllTechnicalSpecificationIsSaved();
            notificationHelpers.success(groupsDisplayTechinicalsSpecificationsAdmin.updateCompleted);
          });
        });
      }
    },
    checkAllTechnicalSpecificationIsSaved() {
      var groupsDisplayTechinicalsSpecificationsAdmin = this;
      groupsDisplayTechinicalsSpecificationsAdmin.rowsSelected = groupsDisplayTechinicalsSpecificationsAdmin.rowsSelected - 1;
      if (groupsDisplayTechinicalsSpecificationsAdmin.rowsSelected == 0) {
        groupsDisplayTechinicalsSpecificationsAdmin.onTechnicalSpecificationTab();
      }
    },
    confirmSaveOrderTechinicalsSpecifications() {
      var groupsDisplayTechinicalsSpecificationsAdmin = this;
      if (groupsDisplayTechinicalsSpecificationsAdmin.$refs.tableTechnicalsSpecificationsIncluded.haveRowSelected(true)) {
        if (confirm(groupsDisplayTechinicalsSpecificationsAdmin.confirmSaveRowSelected)) {
          spinnerHelpers.show();
          groupsDisplayTechinicalsSpecificationsAdmin.saveOrderTechinicalsSpecifications();
        }
      }
    },
    saveOrderTechinicalsSpecifications() {
      var groupsDisplayTechinicalsSpecificationsAdmin = this;
      groupsDisplayTechinicalsSpecificationsAdmin.rowsSelected = 0;
      if (groupsDisplayTechinicalsSpecificationsAdmin.$refs.tableTechnicalsSpecificationsIncluded.haveRowSelected(true)) {
        spinnerHelpers.show();
        $.each(groupsDisplayTechinicalsSpecificationsAdmin.$refs.tableTechnicalsSpecificationsIncluded.getRowSelected(),function (i,row) {
          groupsDisplayTechinicalsSpecificationsAdmin.rowsSelected = groupsDisplayTechinicalsSpecificationsAdmin.rowsSelected + 1;
          groupDisplayTechnicalSpecificationServices.updateTechnicalSpecification(row.id,row.order,function (result) {
            groupsDisplayTechinicalsSpecificationsAdmin.checkAllOrderTechinicalsSpecificationsIsSaved();
            notificationHelpers.success(groupsDisplayTechinicalsSpecificationsAdmin.updateCompleted);
          });
        });
      }
    },
    checkAllOrderTechinicalsSpecificationsIsSaved() {
      var groupsDisplayTechinicalsSpecificationsAdmin = this;
      groupsDisplayTechinicalsSpecificationsAdmin.rowsSelected = groupsDisplayTechinicalsSpecificationsAdmin.rowsSelected - 1;
      if (groupsDisplayTechinicalsSpecificationsAdmin.rowsSelected == 0) {
        groupsDisplayTechinicalsSpecificationsAdmin.onTechnicalSpecificationTab();
      }
    }
  }
}
</script>
